import React, { useEffect } from 'react';
import { Modal, Translate } from '../../../Share/components';
import './style.scss';
import { isIE } from '../../../Share/utils';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  fetchInformationPages,
  markInformationPageAsRead,
} from '../../actions';
import moment from 'moment';

function InformationContainer({
  fetchInformationPages = () => {},
  informationPages = [],
  markInformationPageAsRead = () => {},
}) {
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [information, setInformation] = React.useState(null);

  const sortedInformationPages = [...informationPages].sort(
    (a, b) => new Date(b.DatetimePublish) - new Date(a.DatetimePublish),
  );

  useEffect(() => {
    fetchInformationPages();
  }, []);

  const InfoImage = ({ imageBase64 = '' }) => {
    if (!imageBase64) return null;

    const src = `data:image/png;base64,${imageBase64}`;

    return <img className="tv-information-modal__image" src={src} alt="Info" />;
  };

  const handleReadInformation = informationPageId => {
    markInformationPageAsRead(informationPageId);
  };

  const formatSwedishDate = date => {
    const formatted = moment(date).locale('sv').format('dddd DD MMMM YYYY');

    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  };

  return (
    <>
      <div className="tv-information__page">
        <h2 className="tv-information__page__title">Aktuellt</h2>
        <div className="tv-information__container-fluid  ">
          {sortedInformationPages.map(item => (
            <div key={item.InformationPageIdentifier}>
              <div
                className="tv-information__container"
                role="button"
                onClick={() => {
                  setInformation(item);
                  setIsModalVisible(true);
                  if (!item.IsRead) {
                    handleReadInformation(item.InformationPageIdentifier);
                  }
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    setInformation(item);
                    setIsModalVisible(true);
                    if (!item.IsRead) {
                      handleReadInformation(item.InformationPageIdentifier);
                    }
                  }
                }}
                tabIndex={0}
              >
                <div className="tv-information__wrapper">
                  <div className="tv-information__title">
                    {!item.IsRead && (
                      <div className="tv-information__new-label">
                        {Translate({ content: 'notification.new' })}
                      </div>
                    )}
                    {item.Title}
                  </div>
                  <div className="tv-information__date">
                    <i className="fa fa-clock" />
                    <span>{formatSwedishDate(item.DatetimePublish)}</span>
                  </div>
                </div>
                <div
                  className="tv-general-notification__message tv-general-notification__message-forpage"
                  dangerouslySetInnerHTML={{ __html: item.Introduction }}
                />
                <span className="tv-information__read-more">Läs mer</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      {isModalVisible && (
        <Modal
          isVisible={isModalVisible}
          className="tv-information-modal__container"
          onCloseClicked={() => {
            setIsModalVisible(false);
          }}
          onOverlayClick={() => {}}
          headerText={
            information ? information.Title : 'Detaljerad information'
          }
          ieOptionClassName={isIE ? 'ie-fix-height' : ''}
          headerClassName={`tv-banner-modal-header ${isIE ? 'ie-fix-width' : ''}`}
        >
          <div className="tv-information-modal__content">
            <div className="tv-information__date">
              <i className="fa fa-clock" />
              <span>{formatSwedishDate(information.DatetimePublish)}</span>
            </div>
            <div
              className="tv-information-modal__introduction"
              dangerouslySetInnerHTML={{ __html: information.Body }}
            />

            {InfoImage({ imageBase64: information.Image })}
          </div>
        </Modal>
      )}
    </>
  );
}

const propTypes = {
  informationPages: PropTypes.arrayOf(PropTypes.object),
  fetchInformationPages: PropTypes.func,
  markInformationPageAsRead: PropTypes.func,
};

InformationContainer.propTypes = propTypes;

const mapStateToProps = (state, props) => ({
  informationPages: state.user.informationPages || [],
});

const mapDispatchToProps = dispatch => ({
  fetchInformationPages: () => {
    dispatch(fetchInformationPages());
  },
  markInformationPageAsRead: informationPageId => {
    dispatch(markInformationPageAsRead(informationPageId));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InformationContainer);
